import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { TweenMax, TimelineMax, CSSPlugin, Expo } from 'gsap/all';
import DrawSVGPlugin from '../gsap-bonus/DrawSVGPlugin';
import ScrollMagic from 'scrollmagic';


import '../styles/components/details.scss';


import back from '../assets/back.png';



export default class Details extends Component {

    constructor(props) {
      super(props);
      this.btrigger = null;
      this.bStroke = null;
      this.back = null;
    }

    componentDidMount() {

      TweenMax.set(this.bStroke, {
        drawSVG: 0,
        visibility: 'visible'
      })

      TweenMax.set(this.back, {
        opacity: 0
      })

      const backTl = new TimelineMax({paused: true});
      backTl.to(this.bStroke, 1.5, {
        drawSVG: '100%',
        ease: Expo.easeInOut
      })
      .to(this.back, 0.5, {
        opacity: 1
      }, '-=0.125')
      .to(this.bStroke, 0.5, {
        opacity: 0
      }, '-=0.25')


      const backController = new ScrollMagic.Controller();
      const backScene = new ScrollMagic.Scene({
        triggerElement: this.btrigger,
        triggerHook: "onLeave",
        reverse: true
      }).addTo(backController);

      backScene.on("enter", function (event) {
        backTl.play();
      });
    }

    render() {

        return (
          <div className="details">
            <span ref={span => this.btrigger = span} className="bTrigger" />
            <div className="image-group">
              <img ref={img => this.back = img} src={ back } alt='' />
              <svg viewBox="0 0 610.81 415.38">
                <path ref={path => this.bStroke = path} d="M141.19,29.21s53.59-13.83,131.88-14.33a2.41,2.41,0,0,1,1.15.28l1.41.73a2.46,2.46,0,0,0,1.16.29c9.79-.08,133.57-1,147.08.1a2.44,2.44,0,0,0,1.79-.58h0a2.5,2.5,0,0,1,1.63-.6c8.72.08,77.34,1.12,131.34,14.11,5.37,1.49,21.59,6.87,31.23,10.1a47.54,47.54,0,0,1,13.53,7.13c5.29,4,12.64,9.46,16.2,11.78a46.47,46.47,0,0,1,8.21,6.71c10.93,11.4,30.54,41.93,25.53,115,0,4.77-3.47,50.82-2.61,56.9.44,6.52,6.52,155.08-50.82,180.71-3.91,2.17-39.53,13-68.2,8.68-21.72-6.08-33-11.72-80.79-23-10-5.21-19.12-13.9-29.11-28.23-11.73.86-143.35,0-143.35,0s-9.55,22.15-32.57,29.53c-17.49,4.46-58.53,16.05-75,20.73A46.59,46.59,0,0,1,156.08,427c-14.91-.63-46.88-2.54-54.08-7.38a49.5,49.5,0,0,0-4.76-2.94c-13.69-7.09-54.95-36.18-47.41-200a51.6,51.6,0,0,0-.11-6.34c-1.52-18.34-7.41-67.91,1.11-95.1,7-27.23,10.51-43.49,29.83-55.85a75.84,75.84,0,0,0,6.82-4.85c9.48-7.7,18-15,21.13-15.75C112.08,37.9,141.19,29.21,141.19,29.21Z" transform="translate(-44.82 -13.38)"/>
              </svg>
            </div>
            <div className="info">
              <span className="smallTitle">VIVE&trade; PRO</span>
              <span className="bigTitle">Next Generation VR</span>
              <p>Discover a new world of unexpected gaming experiences with VIVE&trade; PRO. Step into incredible virtual worlds and overcome new challenges in extraordinary ways.</p>
              <div className="more">
                <span />
                <Link to='/'><p>Learn More</p></Link>
              </div>
            </div>
          </div>
        );
    }
}
